import { fetchBranches, createBranch as apiCreateBranch, updateBranch as apiUpdateBranch, deleteBranch as apiDeleteBranch } from '../services/branchApi.js';

export const createBranchSlice = (set, get) => ({
  branches: [],
  selectedBranch: null,
  loading: false,
  error: null,
  dialogLoading: false,

  setBranches: (branches) => set({ branches }),
  setSelectedBranch: (branch) => set({ selectedBranch: branch }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setDialogLoading: (loading) => set({ dialogLoading: loading }),

  loadBranches: async () => {
    set({ loading: true, error: null });
    try {
      const response = await fetchBranches();
      const branchList = response.branches || [];
      set({
        branches: branchList,
        selectedBranch: branchList[0] || null,
        loading: false
      });
    } catch (err) {
      set({
        error: err.message || 'Unable to load branches',
        loading: false
      });
    }
  },

  createBranch: async (branchData) => {
    set({ dialogLoading: true });
    try {
      const response = await apiCreateBranch(branchData);
      const createdBranch = response.branch;
      set((state) => ({
        branches: [...state.branches, createdBranch],
        selectedBranch: createdBranch,
        dialogLoading: false
      }));
      return createdBranch;
    } catch (err) {
      set({ dialogLoading: false });
      throw err;
    }
  },

  updateBranch: async (id, branchData) => {
    set({ dialogLoading: true });
    try {
      const response = await apiUpdateBranch(id, branchData);
      const updatedBranch = response.branch;
      set((state) => ({
        branches: state.branches.map((branch) =>
          branch.id === id ? updatedBranch : branch
        ),
        selectedBranch: updatedBranch,
        dialogLoading: false
      }));
      return updatedBranch;
    } catch (err) {
      set({ dialogLoading: false });
      throw err;
    }
  },

  deleteBranch: async (id) => {
    try {
      await apiDeleteBranch(id);
      set((state) => ({
        branches: state.branches.filter((branch) => branch.id !== id),
        selectedBranch: state.selectedBranch?.id === id ? null : state.selectedBranch
      }));
    } catch (err) {
      throw err;
    }
  },

  toggleBranchStatus: async (branch) => {
    const newState = branch.state === 'Active' ? 'Inactive' : 'Active';
    return get().updateBranch(branch.id, { ...branch, state: newState });
  }
});